if (!customElements.get('compact-quick-add')) {
  class CompactQuickAdd extends DetailsDisclosure {
    connectedCallback() {
      // No <details> when the row has no buy button (GWP offer removed) — nothing to wire up.
      if (!this.querySelector('details')) return;

      super.connectedCallback();

      this.onKeyUp = this.onKeyUp.bind(this);
      this.addEventListener('keyup', this.onKeyUp);

      // Let links inside <summary> navigate instead of just toggling the row.
      this.querySelectorAll('summary a').forEach((link) =>
        link.addEventListener('click', (event) => event.stopPropagation())
      );
    }

    disconnectedCallback() {
      this.removeEventListener('keyup', this.onKeyUp);
    }

    // Opt out of the base class's focusout-close — several rows should stay expanded at once.
    onFocusOut() {}

    onToggle() {
      super.onToggle();
      this.mainDetailsToggle
        .querySelector('summary')
        ?.setAttribute('aria-expanded', String(this.mainDetailsToggle.hasAttribute('open')));
    }

    onKeyUp(event) {
      if (event.code !== 'Escape') return;
      if (!this.mainDetailsToggle?.hasAttribute('open')) return;

      this.close();
      this.mainDetailsToggle.querySelector('summary')?.focus();
    }
  }

  customElements.define('compact-quick-add', CompactQuickAdd);
}
